import { JSONType } from 'Typings/Global';
import { TSetting, TEventSetting } from './@types';

export const parseSetting = (obj: JSONType): TSetting =>
  ({ ...obj } as TSetting);
export const parseEventSetting = (obj: JSONType): TEventSetting =>
  ({ ...obj } as TEventSetting);
